<template>
  <div>
    <el-button size="mini" @click="dialogVisible = true">获取经纬度</el-button>
    <el-dialog
      title="选择坐标"
      fullscreen
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="closeHandle"
      :visible.sync="dialogVisible"
    >
      <el-row>
        <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box>
        <div class="amap-page-container">
          <el-amap :vid="'amap-vue'" :zoom="zoom" :center="center" :events="events">
            <el-amap-marker :position="marker.position" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"></el-amap-marker>
          </el-amap>
        </div>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      q: "",
      zoom: 13,
      marker: {
        position: [120.36173, 36.082949],
        visible: true,
        draggable: false,
      },
      searchOption: {
        city: "青岛",
        citylimit: false,
      },
      events: {
        click: (e) => {
          this.marker.position = [e.lnglat.lng, e.lnglat.lat];
        },
      },
      dialogVisible: false,
      center: [120.36173, 36.082949],
    };
  },
  methods: {
    open(lng, lat) {
      if (lng && lat) {
        this.center = [lng, lat];
        this.marker.position = [lng, lat];
      }
      this.dialogVisible = true;
    },
    onSearchResult(pois) {
      let latSum = 0;
      let lngSum = 0;
      pois.forEach((poi) => {
        lngSum += poi.lng;
        latSum += poi.lat;
      });
      let center = {
        lng: lngSum / pois.length,
        lat: latSum / pois.length,
      };
      this.center = [center.lng, center.lat];
      this.marker.position = [center.lng, center.lat];
    },
    submit() {
      log(this.marker.position);
      this.$emit("callback", this.marker.position);
      this.dialogVisible = false;
    },
    // 弹窗关闭时
    closeHandle() {},
  },
};
</script>

<style>
.amap-page-container {
  width: 100%;
  height: 450px;
}

.search-box {
  margin-top: 0px;
  position: relative;
  top: 65px;
  left: 20px;
}
</style>
